import { useContext, useEffect } from 'react';
import { DispatchEvent, State } from '../../../../../../library/Core/SmartTypes';
import { SmartContext } from '../../../../../../library/Core/SmartContext';
import PageBuilder from '../../../../../../library/Builders/PageBuilder/PageBuilder';
import EditInterestsFormLayout from './EditInterestsFormLayout';
import ProfileMarkerService from './ProfileMakerService';

const EditInterestsModal = ({ userdata, markerType }: any) => {
    const { state, dispatch } = useContext(SmartContext);
    const { saveMarker, fetchUserProfileMarkers } = ProfileMarkerService();
    const handleSave = async (
        event: React.SyntheticEvent<HTMLButtonElement>,
        state: State,
        dispatch: (dispatchEvent: DispatchEvent) => void
    ) => {
        event.preventDefault();
        console.log('form_submit');
         console.log("markerType",markerType)

        if (state?.data?.visibleControl === 'respondedToFeedBackSurvey') {
            const feedbackSurveyValue = state?.data?.general?.respondedToFeedBackSurvey;
            console.log("feedbackSurveyValue",feedbackSurveyValue)
            const feedbackSurveyValueStr = String(feedbackSurveyValue).trim();

            // Check if the value is valid, not empty, and not negative
            if (isNaN(feedbackSurveyValue) || feedbackSurveyValueStr === '' || parseInt(feedbackSurveyValueStr) < 0) {
                alert("Please enter a valid Feedback Survey Value value.");
                return;
            }
        }

        let payload = {
            markerType:markerType,
            ...(state?.data?.[markerType] || {}),
        };

        await saveMarker({...payload,syncData : state?.data?.syncData?.[0] || {}}, state?.internal?.model?.id);
        await fetchUserProfileMarkers(state?.internal?.model?.id);
        dispatch({ type: 'TOGGLE_MODAL_VISIBILITY', payload: { modalName: 'showInterestsModal' } });
    };

    useEffect(() => {
        dispatch({ type: 'ADD_ACTIONS', payload: { ...state.actions, SAVE: handleSave } });
    }, []);

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <EditInterestsFormLayout>{!state.flags.isDataLoading && <PageBuilder />}</EditInterestsFormLayout>
        </SmartContext.Provider>
    );
};

export default EditInterestsModal;
